import request from '@/utils/request'

// 查询报价计算列表
export async function listDocQuotationCalculation(query) {
  console.log(query)
  return request({
    url: '/system/docQuotationCalculation/list',
    method: 'get',
    params: query
  })
}

// 查询报价计算详细
export function getDocQuotationCalculation(id) {
  return request({
    url: '/system/docQuotationCalculation/' + id,
    method: 'get'
  })
}

// 新增报价计算
export function addDocQuotationCalculation(data) {
  return request({
    url: '/system/docQuotationCalculation',
    method: 'post',
    data: data
  })
}

// 修改报价计算
export function updateDocQuotationCalculation(data) {
  return request({
    url: '/system/docQuotationCalculation',
    method: 'put',
    data: data
  })
}

// 删除报价计算
export function delDocQuotationCalculation(id) {
  return request({
    url: '/system/docQuotationCalculation/' + id,
    method: 'delete'
  })
}

// 导出报价计算
export function exportDocQuotationCalculation(query) {
  return request({
    url: '/system/docQuotationCalculation/export',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/docQuotationCalculation.js